<script setup>
import TabItem from "@/components/global-themed/tabs/TabItem.vue";
import TabContainer from "@/components/global-themed/tabs/TabContainer.vue";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();

const activeTab = computed(() => store.getters['backlinks/activeTab']);
const orderBy = computed(() => store.getters['backlinks/orderBy']);

const changeTab = (type) => {
  store.dispatch('backlinks/setActiveTab', type)

  if (type === 'lost' && orderBy.value === 'found') {
    store.dispatch('backlinks/setOrderBy', 'lost');
    return;
  }

  if (type !== 'lost' && orderBy.value === 'lost') {
    store.dispatch('backlinks/setOrderBy', 'found');
  }
}
const tabs = [
  {
    key: 'live',
    text: 'Live',
    icon: 'stop-watch',
    tooltip: 'View all active backlinks currently pointing to your website.',
  },
  {
    key: 'disavowed',
    text: 'Disavowed',
    icon: 'disavowed',
    tooltip: 'See the list of backlinks you have disavowed from within the backlink health check section.',
  },
  {
    key: 'lost',
    text: 'Lost',
    icon: 'magic-wand',
    tooltip: 'Check the backlinks that are no longer pointing to your website.',
  },
  {
    key: 'authority',
    text: 'Authority',
    icon: 'rankings',
    tooltip: 'See an overview of your websites authority over time.',
  },
]
</script>

<template>
  <TabContainer>
    <TabItem
      v-for="{key, text, icon, tooltip} in tabs"
      :key="key"
      v-tooltip="{
        content: `${tooltip}`,
        placement: 'bottom',
        theme: 'dark-blue-tooltip',
      }"
      :active="activeTab === key"
      class="tw-flex tw-items-center tw-justify-center tw-space-x-3"
      @click="changeTab(key)"
    >
      <svg-vue
        :icon="`icons/${icon}`"
        class="tw-w-6 tw-h-6"
        :class="{'tw-text-grey': activeTab === key}"
      />
      <span class="tw-font-bold">{{ text }}</span>
    </TabItem>
  </TabContainer>
</template>
